import {
    type DayOfWeek,
    type WorkforceAvailabilityCell,
    type WorkforceAvailabilityRow,
} from '@libraries/typescript/api_client';

export type CellState = WorkforceAvailabilityCell['state'];
export type DayPartKey = WorkforceAvailabilityCell['day_part'];

export type CoverageRow = WorkforceAvailabilityRow;
export type WorkWeekStartDay = DayOfWeek;

export const DAY_INDEXES = [0, 1, 2, 3, 4, 5, 6] as const;

export const DAY_PARTS: ReadonlyArray<{
    readonly key: DayPartKey;
    readonly label: string;
    readonly timeLabel: string;
}> = [
    { key: 'morning', label: 'Morning', timeLabel: '6am–12pm' },
    { key: 'afternoon', label: 'Afternoon', timeLabel: '12–5pm' },
    { key: 'evening', label: 'Evening', timeLabel: '5–9pm' },
    { key: 'overnight', label: 'Overnight', timeLabel: '9pm–6am' },
];

export const CELL_STATE_LABELS: Record<CellState, string> = {
    available: 'Available',
    partially_available: 'Partially available',
    scheduled: 'Scheduled',
    unavailable: 'Unavailable',
    unknown: 'No data',
};

export type AvailabilityMatchMode = 'every' | 'any';

export type CoverageFilters = {
    readonly search: string;
    readonly offices: ReadonlyArray<string>;
    readonly cities: ReadonlyArray<string>;
    readonly zips: ReadonlyArray<string>;
    readonly days: ReadonlyArray<number>;
    readonly dayParts: ReadonlyArray<DayPartKey>;
    readonly tags: ReadonlyArray<string>;
    readonly employmentTypes: ReadonlyArray<string>;
    readonly availability: 'any' | 'unknown_only';
    /**
     * How selected days combine: 'every' keeps caregivers open on all
     * selected days ("free Sat AND Sun evenings"); 'any' keeps caregivers
     * open on at least one ("someone for Westminster evenings"), which is
     * what a coverage-cell click-through means.
     */
    readonly matchMode: AvailabilityMatchMode;
};

export const EMPTY_FILTERS: CoverageFilters = {
    search: '',
    offices: [],
    cities: [],
    zips: [],
    days: [],
    dayParts: [],
    tags: [],
    employmentTypes: [],
    availability: 'any',
    matchMode: 'every',
};

export const EMPLOYMENT_TYPE_LABELS: Record<string, string> = {
    full_time: 'Full time',
    part_time: 'Part time',
    prn: 'PRN',
    per_diem: 'Per diem',
    contract: 'Contract',
    temp: 'Temp',
    unknown: 'Unknown',
};
